import Dropdown from './Dropdown-view'
// TODO Развить возможности компонента до dropdown из block.simple,
// TODO сделать декомпозицию по функциональности: поиск, теги, мультиселект

export default Dropdown
